import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormat, DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'
import { getGenderName } from '../../../models/user'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '体检单号',
      dataIndex: 'id',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.id ? t.id : '-'
      },
    },
    {
      title: '员工姓名',
      dataIndex: 'employeeName',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.employeeName ? t.employeeName : '-'
      },
    },
    {
      title: '性别',
      dataIndex: 'sex',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.sex?.toString() ? getGenderName(Number(t.sex)) : '-'
      },
    },
    {
      title: '体检机构',
      dataIndex: 'examOrganization',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.examOrganization ? t.examOrganization : '-'
      },
    },
    {
      title: '体检内容',
      dataIndex: 'examContent',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.examContent
          ? t.examContent 
          : '-'
      },
    },
    {
      title: '体检结果',
      dataIndex: 'examResult',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.examResult ? t.examResult  : '-'
      },
    },
    {
      title: '体检日期',
      dataIndex: 'examDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.examDate ?moment(t.examDate).format(DateTimeFormatSimple): '-'
      },
    },
    {
      title: '采取措施',
      dataIndex: 'measures',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.measures
          ? t?.measures
          : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              style={{ marginRight: '6px' }}
              type='primary'
              ghost
              size='small'
              disabled={t?.isEdit == 1 ? false : true}
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]
}
